'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var styled = require('styled-components');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
var radioGroup = require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
require('../../../../themes/alert.js');
require('../../../../themes/button.js');
require('../../../../themes/checkbox.js');
require('../../../../themes/divider.js');
require('../../../../themes/dropdown.js');
require('../../../../themes/fieldset.js');
require('../../../../themes/input.js');
require('../../../../themes/list.js');
require('../../../../themes/listbox.js');
require('../../../../themes/loader.js');
require('../../../../themes/option.js');
require('../../../../themes/popout.js');
require('../../../../themes/switch.js');
var themes = require('../../../../themes/themes.js');
require('../../../../themes/tooltip.js');
var standardRadio = require('../standard-radio/standard-radio.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const UnstyledRadioGroup = (props)=>{
    const { className , layout , radios , ...otherProps } = props;
    return /*#__PURE__*/ React__default.default.createElement("div", _extends({}, otherProps, {
        className: classnames__default.default({
            'bf-radio-group': true,
            [`bf-radio-group--layout-${layout}`]: layout,
            [`${className}`]: !!className
        })
    }), radios.map((radio)=>{
        return /*#__PURE__*/ React__default.default.createElement(standardRadio.StandardRadio, _extends({
            key: radio.id
        }, radio));
    }));
};
const StyledRadioGroup = styled__default.default(UnstyledRadioGroup)`
  display: flex;

  &.bf-radio-group--layout-${radioGroup.RadioGroupLayouts.Horizontal} {
    flex-direction: row;
    flex-wrap: wrap;

    > .bf-radio__standard {
      margin-block-end: 12px;
      margin-inline-end: 56px;

      &:last-child {
        margin-inline-end: 0;
      }
    }
  }

  &.bf-radio-group--layout-${radioGroup.RadioGroupLayouts.Vertical} {
    flex-direction: column;

    > .bf-radio__standard {
      margin-block-end: 24px;

      &:last-child {
        margin-block-end: 0;
      }
    }
  }
`;
/**
 * A group of `<StandardRadio>` components with styling.
 *
 * Possible layouts are `RadioGroupLayouts.Vertical` (default) and
 * `RadioGroupLayouts.Horizontal`.
 *
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/radio
 *
 * @param props RadioGroupProps
 * @returns FunctionComponent<RadioGroupProps>
 */ const RadioGroup = (props)=>{
    const { layout =radioGroup.RadioGroupLayouts.Vertical , ...otherProps } = props;
    const themeContext = React.useContext(styled.ThemeContext);
    return /*#__PURE__*/ React__default.default.createElement(styled.ThemeProvider, {
        theme: themeContext || themes.lightTheme
    }, /*#__PURE__*/ React__default.default.createElement(StyledRadioGroup, _extends({}, otherProps, {
        layout: layout
    })));
};

exports.RadioGroup = RadioGroup;
exports.UnstyledRadioGroup = UnstyledRadioGroup;
//# sourceMappingURL=radio-group.js.map
